<dx-report-designer *ngIf="reportUrl!=undefined && getDesignerModelAction && hostUrl" [reportUrl]="reportUrl" height="700px">
    <dxrd-request-options [getDesignerModelAction]="getDesignerModelAction" [host]="hostUrl"></dxrd-request-options>
</dx-report-designer>